import React, { useCallback, useRef, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import ActionModal from '../../Modal/ActionModal'
import { useLongPress } from 'use-long-press'
import TOOLS from '../../../services/tools'
import MobileOption from '../../Commons/MobileOption'
import DefaultOptions from '../../Commons/DefaultOptions'
import Loader from '../../Commons/Loaders/Loader'

const PartnerCardTable = ({
    rows,
    totalItems,
    handleDeleteElement,
    loading,
}) => {
    let history = useNavigate()
    const location = useLocation()
    const [showMobileOptions, setShowMobileOptions] = useState(false)
    const [showOptions, setShowOptions] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)
    const [selectedRowId, setSelectedRowId] = useState(null)
    const [styleId, setStyleId] = useState(null)
    const [label, setLabel] = useState('')
    const [labelAction, setLabelAction] = useState('')
    const [actionButton, setActionButton] = useState('')

    const historyPush = (id) => {
        history(location.pathname + '/' + id)
    }

    const handleAction = () => {
        setModalOpen(false)
        handleDeleteElement(selectedRowId)
    }

    const handleModalDelete = (rowId) => {
        let row = rows.find((r) => r.id === rowId)
        setLabel(
            'Êtes-vous sûr de vouloir supprimer le partenaire ' +
                row['firstname'] +
                ' ' +
                row['lastname'] +
                ' ?'
        )
        setActionButton('Supprimer')
        setLabelAction('Suppression')
        setModalOpen(true)
    }
    const optionsRef = useRef()

    TOOLS.useOnClickOutside(optionsRef, () => {
        setShowOptions(false)
        setStyleId(null)
    })

    const callback = useCallback((event) => {}, [])

    const bind = useLongPress(callback, {
        onStart: (event) => {
            setSelectedRowId(parseInt(event.currentTarget.id))
            setStyleId(parseInt(event.currentTarget.id))
        },
        onFinish: (event) => setShowMobileOptions(true),
        onCancel: (event) => {
            setSelectedRowId(null)
            setStyleId(null)
            setShowMobileOptions(false)
        },
        onMove: (event) => console.log('Detected mouse or touch movement'),
        threshold: 300,
        captureEvent: true,
        cancelOnMovement: true,
        detect: 'touch',
    })

    return (
        <div className="px-2 text-lg lg:text-base xl:pt-5">
            <div className="flex py-2">
                <div className="ml-auto font-bold lg:text-xs">
                    {totalItems} Partenaires
                </div>
            </div>
            {loading ? (
                <Loader />
            ) : (
                <div>
                    {rows.map((row) => (
                        <div
                            className="parents relative flex w-full pb-2"
                            key={row.id}
                        >
                            <div
                                key={row.id}
                                className={`grid w-full  cursor-pointer select-none rounded bg-white shadow-mobile lg:select-auto ${
                                    row.special
                                        ? 'border-l-8 border-blue-200'
                                        : null
                                } ${row.id === styleId ? ' ring' : null} `}
                                id={row.id}
                                {...bind}
                                onClick={() => historyPush(row.id)}
                            >
                                <div
                                    className={`parents row-span-1 flex grid-rows-1  flex-wrap items-center justify-between px-2 py-2  text-lg lg:text-base`}
                                >
                                    <div
                                        className="w-1/2 truncate sm:w-1/4 "
                                        title={row.firstname}
                                    >
                                        {row.firstname}
                                    </div>
                                    <div
                                        className="w-1/2 truncate sm:w-1/4 "
                                        title={row.lastname}
                                    >
                                        {row.lastname}
                                    </div>
                                    <div
                                        className="w-1/2 truncate sm:w-1/4 "
                                        title={row.email}
                                    >
                                        {row.email}
                                    </div>
                                    <div
                                        className="flex w-1/2 align-middle text-base sm:w-1/4 lg:px-2 lg:text-lg xl:items-center"
                                        title={row.phoneNumber}
                                    >
                                        <div className="flex items-center align-middle xl:w-1/2">
                                            <div className="flex w-full items-center align-middle">
                                                <i className="fa fa-phone pr-2" />
                                                <div className="truncate">
                                                    {row.phoneNumber}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={`absolute right-0 hidden h-10 cursor-pointer rounded pt-2 xl:block   ${
                                        row.id === selectedRowId
                                            ? null
                                            : 'options '
                                    } `}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        setShowOptions(true)
                                        setSelectedRowId(row.id)
                                        setStyleId(row.id)
                                    }}
                                >
                                    <i
                                        className={`fas fa-ellipsis-h w-20 pr-4 pt-1 text-right ${
                                            showOptions ? 'hidden' : ''
                                        } `}
                                    />
                                    {row.id === selectedRowId && showOptions ? (
                                        <DefaultOptions
                                            setShowMobileOptions={
                                                setShowOptions
                                            }
                                            rowId={selectedRowId}
                                            handleModalDelete={
                                                handleModalDelete
                                            }
                                            historyPush={historyPush}
                                            historyPushUpdate={historyPush}
                                            optionsRef={optionsRef}
                                        />
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            {showMobileOptions ? (
                <MobileOption
                    setShowMobileOptions={setShowMobileOptions}
                    rowId={selectedRowId}
                    handleModalDelete={handleModalDelete}
                    historyPush={historyPush}
                    historyPushUpdate={historyPush}
                    historyPushCopy={null}
                    setStyleId={setStyleId}
                />
            ) : null}
            {modalOpen ? (
                <ActionModal
                    setModalOpen={setModalOpen}
                    label={label}
                    action={handleAction}
                    labelAction={labelAction}
                    actionButton={actionButton}
                />
            ) : null}
        </div>
    )
}

export default PartnerCardTable
